import React, { memo } from "react";
import { Grid } from "components/src/components/Grid/Grid";
import { spanMap } from "../js/MarketHeaderHelpers";
import { MarketLabel } from "./MarketLabel";

export interface LabelsRowProps {
  labels: (string | { text: string; hasSGP?: boolean })[];
  numLabels: number;
  isOddsBoost?: boolean;
  noLabels?: boolean;
  textSize?: string;
  textColor?: string;
}

export const MarketHeaderLabelsRow = memo(({ labels, numLabels, isOddsBoost, noLabels, textSize, textColor }: LabelsRowProps) => {
  if (noLabels) return null;
  
  return (
    <>
      <Grid.Cell colSpan={isOddsBoost ? spanMap[numLabels] - 1 : spanMap[numLabels]} className="body-xs cui-text-fg-moderate" />
      {labels.map((label, i) => (
        <MarketLabel key={`mh-${i}`} label={label} index={i} isOddsBoost={isOddsBoost} textSize={textSize} textColor={textColor} />
      ))}
    </>
  );
});

MarketHeaderLabelsRow.displayName = "MarketHeaderLabelsRow";
